import React from 'react';
import './AdminSidebar.css';

function AdminSidebar({ currentSection, setCurrentSection, collapsed, setCollapsed }) {
  const menuItems = [
    { id: 'news', icon: '📰', label: 'News Management', description: 'Create and manage updates' },
    { id: 'users', icon: '👥', label: 'User Management', description: 'Manage user accounts' },
    { id: 'content', icon: '📚', label: 'Content Management', description: 'Manage source materials' },
    { id: 'feedback', icon: '💬', label: 'Feedback Management', description: 'View user feedback' },
    { id: 'settings', icon: '⚙️', label: 'System Settings', description: 'Configure application' }
  ];

  return (
    <div className={`admin-sidebar ${collapsed ? 'collapsed' : ''}`}>
      {/* Sidebar Header */}
      <div className="sidebar-header">
        <div className="sidebar-title">
          {!collapsed && (
            <>
              <span className="admin-icon">🛠️</span>
              <h2>Admin Panel</h2>
            </>
          )}
        </div>
        <button 
          className="collapse-toggle"
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
        >
          {collapsed ? '▶' : '◀'}
        </button>
      </div>

      {/* Navigation Menu */}
      <nav className="sidebar-nav">
        {menuItems.map(item => (
          <button
            key={item.id}
            className={`nav-item ${currentSection === item.id ? 'active' : ''}`}
            onClick={() => setCurrentSection(item.id)}
            title={collapsed ? item.label : ''}
          >
            <span className="nav-icon">{item.icon}</span>
            {!collapsed && (
              <div className="nav-text">
                <span className="nav-label">{item.label}</span>
                <span className="nav-description">{item.description}</span>
              </div>
            )}
          </button>
        ))}
      </nav>

      {/* Sidebar Footer */}
      {!collapsed && (
        <div className="sidebar-footer">
          <div className="footer-info">
            <span className="info-icon">ℹ️</span>
            <p>Select a section to manage different aspects of the application.</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminSidebar;
